/* The mockup's `.chip.chip-sm` tags and the tag button of the editor's topbar. */
.tags {
  display: inline-flex;
  align-items: center;
  gap: var(--space-1);
}

.tag {
  display: inline-flex;
  align-items: center;
  block-size: 24px;
  padding: 0 var(--space-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-pill);
  background: var(--surface-raised);
  color: var(--text-muted);
  font-size: var(--font-size-12);
  font-weight: var(--font-weight-medium);
  white-space: nowrap;
}

.trigger {
  display: inline-flex;
}

.panel {
  padding: var(--space-3) var(--space-4);
}

/* Owner round 3: what a scope is, above the way to move it. */
.explain {
  margin: 0;
  color: var(--text-muted);
  font-size: var(--font-size-12);
}
